import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {

  private addOfferExternUrlOffer = 'Lien de redirection vers le site de l\'acteur.';
  private addOfferReductionAge = 'Réduction appliquée par tranche d\'âge mentionnée';
  private addOfferReductionQuantity = 'Réduction appliquée en fonction du nombre de réservations par stagiaire';
  private addOfferReductionLicence = 'Réduction appliquée si l\'acheteur mentionne une licence valide';
  private addOfferReductionCity = 'Si l\'acheteur mentionne sa ville de résidence comprise dans cette liste, cette réduction est appliquée';
  private addOfferReductionStagiaire = 'Réduction appliquée en fonction du nombre de stagiaires';
  private detailsClub = 'Afficher les détails de l\'acteur';
  private detailsStructure = 'Afficher les détails de la structure';
  private clubDetailsPracticePlace = 'Afficher la liste des lieux de partique';
  private clubDetailUpdate = 'Modifier les infos de l\'acteur';
  private purchaseHistoryDetails = 'Afficher le résumé de l\'article';
  private showSessionOffer = 'Voir toutes les sessions de l\'article';
  private addSessionOffer = 'Ajouter une session';
  private myShoppingBagPersoOffer = 'Personnaliser l\'article';
  private typeOfOfferAddEdit = 'Si ce champ est activé, une article avec backoffice sera gérée sur ce site. Dans le cas contraire, elle sera gérée sur le site de l\'acteur.';
  private hasSession = 'Si ce champ est activé, l\'article doit avoir au minimum une session configurée.';
  private detailsCounter = 'Afficher le guichet';
  private counterInfosSearch = `Recherche par multicritères: \n- Nom article \n- Nom session \n- Clef de l'article`;
  private downloadBill = 'Télécharger la facture';
  private doSearch = 'Effectuer la recherche';
  private slideShow = 'Défilé d\'images sur les détails de l\'article (non obligatoire). L\'image principale est prise en compte. '
  private goToFilesOffer = 'Afficher les fichiers de cette article';
  private showPreview = 'Changer l\'aperçu';
  private editOffer = 'Éditer l\'article';
  private duplicateOffer = 'Dupliquer l\'article';

  tooltip = {
    'externUrlOffer': this.addOfferExternUrlOffer,
    'reductionAge': this.addOfferReductionAge,
    'reductionQuantity': this.addOfferReductionQuantity,
    'reductionLicence': this.addOfferReductionLicence,
    'reductionCity': this.addOfferReductionCity,
    'reductionStagiaire': this.addOfferReductionStagiaire,
    'detailsClub': this.detailsClub,
    'detailsStructure': this.detailsStructure,
    'clubDetailsStructure': this.clubDetailsPracticePlace,
    'clubDetailUpdate': this.clubDetailUpdate,
    'purchaseHistoryDetails': this.purchaseHistoryDetails,
    'showSessionOffer': this.showSessionOffer,
    'addSessionOffer': this.addSessionOffer,
    'myShoppingBagPersoOffer': this.myShoppingBagPersoOffer,
    'typeOfOfferAddEdit': this.typeOfOfferAddEdit,
    'hasSession': this.hasSession,
    'detailsCounter': this.detailsCounter,
    'counterInfosSearch': this.counterInfosSearch,
    'downloadBill': this.downloadBill,
    'doSearch': this.doSearch,
    'slideShow': this.slideShow,
    'goToFilesOffer': this.goToFilesOffer,
    'showPreview': this.showPreview,
    'editOffer': this.editOffer,
    'duplicateOffer': this.duplicateOffer,
  }

  constructor() { }

  getTooltip(value: string): string {
    return this.tooltip[value];
  }

}
